export const ActionStatus = {
    IDLE: 'idle',
    PENDING: 'pending',
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected'
};

export const SequenceEvaluationStatus = {
    IN_PROGRESS: 'in_progress',
    MISSED: 'missed',
    INTERRUPTED: 'interrupted',
    COMPLETED: 'completed',
    PENDING: 'pending',
    WAITING: 'waiting',
    OK: 'ok'
};
